<div class="dropdown-wrapper relative inline-block">
  <div
    (click)="toggleDropdown()"
    (keydown)="onKeyDown($event)"
    [attr.aria-expanded]="dropdownOpen"
    [attr.aria-haspopup]="true"
    [attr.aria-label]="label"
    [class.cursor-not-allowed]="disabled"
    [class.opacity-50]="disabled"
    class="flex items-center gap-2 px-2 h-7 rounded border bg-white border-[#D0D6DF] cursor-pointer text-[#4E5663] text-sm leading-none focus:outline-none focus:ring-2 focus:ring-[#80A363] focus:border-[#80A363]"
    role="combobox"
    tabindex="0"
  >
    <span class="pl-[2px] pr-[6px]">{{ label }}</span>

    <!-- Badge for selected items in multiple mode -->
    @if (isMultipleMode() && hasSelectedItems()) {
      <div
        class="flex items-center justify-center w-5 h-5 rounded-full bg-[#465A36] text-white text-xs font-bold"
      >
        {{ getSelectedCount() }}
      </div>
    }

    <!-- Display selected option label in single mode -->
    @if (isSingleMode() && hasSelectedItems()) {
      <div class="text-[#465A36] text-xs font-medium truncate max-w-[100px]">
        {{ getSingleSelectedLabel() }}
      </div>
    }

    <!-- Placeholder text when nothing is selected -->
    @if (!isSearchMode() && !hasSelectedItems() && placeholder) {
      <div class="text-gray-400 text-xs truncate max-w-[100px]">
        {{ placeholder }}
      </div>
    }

    <span
      [class.rotate-180]="dropdownOpen"
      class="material-symbols-rounded text-[16px] leading-[16px] transition-transform duration-200"
    >
      keyboard_arrow_down
    </span>
  </div>

  @if (dropdownOpen) {
    <div
      class="absolute mt-1 z-10 rounded shadow-lg bg-white border border-gray-200 p-2 min-w-[220px] max-w-[300px]"
      role="listbox"
      [attr.aria-multiselectable]="multiple"
    >
      @if (isSearchMode()) {
        <div class="px-2 py-1 border-b border-gray-200">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange($event)"
            placeholder="{{ placeholder }}"
            class="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#80A363]"
          />
        </div>
      }

      @if (
        options.length === 0 &&
        (!isSearchMode() ||
          (isSearchMode() && searchTerm && searchTerm.trim().length > 0))
      ) {
        <div class="px-2 py-1 text-sm text-gray-500">
          {{ "multiSelectDropdown.noOptions" | translate }}
        </div>
      }

      @for (option of options; track option.value) {
        <label
          class="relative flex items-center gap-2 cursor-pointer select-none text-sm text-[#6A7381] px-2 py-1 rounded hover:bg-gray-100 focus-within:bg-gray-100"
          [attr.aria-selected]="isSelected(option.value)"
          role="option"
        >
          <!-- Multiple selection with checkbox -->
          @if (isMultipleMode()) {
            <input
              type="checkbox"
              class="peer shrink-0 w-5 h-5 appearance-none border border-gray-400 rounded-[0.25rem] bg-white cursor-pointer checked:bg-[#80A363] checked:border-[#80A363] focus:outline-none focus:ring-2 focus:ring-[#80A363]/50"
              [checked]="isSelected(option.value)"
              [attr.aria-describedby]="'option-' + option.value"
              (change)="onOptionToggle(option.value)"
            />
            <span
              class="pointer-events-none absolute left-[7px] top-[2px] hidden peer-checked:flex items-center justify-center scale-75 font-bold text-white material-symbols-rounded"
              >check</span
            >
            <span
              class="peer-checked:text-[#4E5663] transition-colors duration-150"
              [id]="'option-' + option.value"
              [class.truncate]="isSearchMode()"
              style="max-width: 250px"
            >
              {{ option.label }}
            </span>
          }

          <!-- Single selection -->
          @if (isSingleMode()) {
            <div
              class="cursor-pointer select-none px-2 py-1 rounded hover:bg-gray-100 w-full flex items-center justify-between text-[#6A7381] text-sm transition-colors duration-150"
              [class.font-semibold]="isSelected(option.value)"
              [class.text-[#4E5663]]="isSelected(option.value)"
              (click)="onOptionToggle(option.value)"
            >
              <span>{{ option.label }}</span>
              @if (isSelected(option.value)) {
                <span class="material-symbols-rounded text-[#80A363] text-sm"
                  >check</span
                >
              }
            </div>
          }
        </label>
      }
    </div>
  }
</div>
